import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation createMessageMutation($input: CreateMessageInput!) {
    createMessage(input: $input) {
      messageEdge {
        node {
          ...MessageCell_message
        }
      }
      errors {
        key
        messages
      }
    }
  }
`;

const createMessage = (environment, attributes, listsId, args = {}) => {
  const {
    backgroundImage: messageBackgroundImage,
    ...otherAttributes
  } = attributes;

  const uploadables = messageBackgroundImage
    ? { messageBackgroundImage }
    : null;

  return commit(environment, {
    mutation,
    uploadables,
    variables: {
      input: otherAttributes,
    },
    configs: [
      {
        type: 'RANGE_ADD',
        parentID: listsId,
        edgeName: 'messageEdge',
        connectionInfo: [
          {
            key: 'MessagesList_messages',
            rangeBehavior: 'append',
          },
        ],
      },
    ],
    ...args,
  });
};

export default createMessage;
